import React, { useEffect, useState } from "react";

// import { loginUser, loginUserReq } from "../../../redux/ActionCreators";
import { useDispatch, useSelector } from "react-redux";
import userAction from "../../../redux/users/action";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import Copy from "../../../images/Copy.svg";
import chainIco from "../../../images/Dice.svg";
import { Connector, useConnect, useAccount, useDisconnect } from "wagmi";
import ethIco from "../../../images/ethIco.png";
import api from "../../../api";
import { FaAngleDown, FaTv } from "react-icons/fa";
import {
  LuBriefcaseBusiness,
  LuChartBarStacked,
  LuChartCandlestick,
} from "react-icons/lu";
import { Home } from "lucide-react";
import { GrFolderCycle } from "react-icons/gr";
import { TfiDashboard } from "react-icons/tfi";
import homeIco from "../../../images/homepage/homeIco.svg";
import logo from "../../../images/homepage/logoNew.svg";
import miniLogo from "../../../images/homepage/miniLogo.svg";

export function NavbarPorfoilio({ ethData, wallet }) {
  const { address } = useAccount();
  const { disconnect } = useDisconnect();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userStore = useSelector((state) => state.userReducer);
  const { setUser } = userAction;
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const logout = async () => {
    let payload = {
      _id: userStore?.users?.user?._id,
    };
    let logoutRes = await api.logout(payload);
    dispatch(setUser({}));
    console.log("remove token");

    localStorage.removeItem("token");
    if (address) {
      disconnect();
    }
    navigate("/");
  };

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = token;
    } else {
      logout();
    }
  }, []);

  return (
    <>
      {/* Topbar */}
      <nav className="navbar portfolioNav navbar-expand navbar-light topbar static-top ">
        {/* Sidebar Toggle (Topbar) */}
        {/* <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                  <i className="fa fa-bars" />
                </button> */}
        <Link
          className="sidebar-brand d-flex align-items-center justify-content-center mt-0"
          to="/"
        >
          <div className="mini mx-3">
            <img src={miniLogo} className="w-40" alt="waqarzaka.net" />
          </div>
        </Link>

        {/* Topbar Navbar */}
        <ul className="navbar-nav linkNav">
          <li className="nav-item">
            <Link className="homeNav" aria-current="page" to="/">
              <img src={homeIco} alt="home" />
            </Link>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/market-overview">
              <LuChartBarStacked fontSize={20} />
              Market
            </NavLink>
          </li>

          {userStore?.users?.user?._id && (
            <li className="nav-item">
              <NavLink className="nav-link" to="/portfolio">
                {" "}
                <LuBriefcaseBusiness fontSize={20} />
                Portfolio{" "}
              </NavLink>
            </li>
          )}

          {userStore?.users?.user?._id && (
            <li className="nav-item">
              <NavLink className="nav-link" to="/checkout">
                <GrFolderCycle fontSize={20} />
                Subscription{" "}
              </NavLink>
            </li>
          )}

          {userStore?.users?.user?._id && (
            <>
              <li className="nav-item">
                <NavLink className="nav-link" to="/dashboard">
                  <TfiDashboard fontSize={22} />
                  Dashboard{" "}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/indicators">
                  <LuChartCandlestick fontSize={20} />
                  Indicators{" "}
                </NavLink>
              </li>
            </>
          )}
        </ul>
        {/* <h3 className="head">Dashboard</h3> */}
        {/* <div className="pfNav">
          <NavLink className="nav-link" to="/market-overview">
            Home
          </NavLink>
          <NavLink className="nav-link" to="/market-overview">
            Market
          </NavLink>
          <NavLink className="nav-link" to="/checkout">
            Subscription{" "}
          </NavLink>
          {userStore?.users?.user?._id && (
            <>
              <NavLink className="nav-link" to="/dashboard">
                Dashboard{" "}
              </NavLink>
              <NavLink className="nav-link" to="/indicators">
                Indicators{" "}
              </NavLink>
            </>
          )}
        </div> */}
        <ul className="navbar-nav ml-auto">
          {wallet && (
            <li>
              <div className="chainM">
                <div className="chain me-3">
                  <div className="ico">
                    <img src={ethIco} alt="" />
                  </div>
                  {ethData?.ETH?.balance ? ethData?.ETH?.balance.toFixed(5) : 0}
                </div>
                <div className="chain">
                  <div className="ico">
                    <img src={chainIco} alt="" />
                  </div>
                  {wallet
                    ? wallet.slice(0, 5) +
                      "..." +
                      wallet.slice(wallet.length - 4, wallet.length)
                    : "Ethereum"}
                </div>
              </div>
            </li>
          )}
          <li className="nav-item dropdown no-arrow me-3 portLi">
            <button
              className="themeBtn "
              href="#"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div className="profile-div ml-2 small">
                {userStore?.users?.user?.name
                  ? userStore?.users?.user?.name
                  : "User Name"}{" "}
              </div>
              <div className="ms-2">
                <FaAngleDown />
              </div>
            </button>
            <div
              className="dropdown-menu dropdown-menu-left shadow animated--grow-in px-2"
              aria-labelledby="userDropdown"
            >
              <a className="dropdown-item" onClick={logout}>
                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 " />
                Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>
      {/* End of Topbar */}
    </>
  );
}
